import React from 'react';
import { Button } from 'react-bootstrap';
import { InputText, NumericSelect } from '../../../../formikBindings';
import { FieldArray } from 'formik';
import { IQuestionListProps } from './types';
import QuestionFactory from '../QuestionFactory';
import styles from './QuestionList.module.css';
import { FormControlErrorMessage } from '../../../../form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuestionList: React.FC<IQuestionListProps> = ({
  sectionIndex,
  questions,
}) => (
  <FieldArray
    name={`sections.${sectionIndex}.questions`}
    validateOnChange={false}
    render={(questionsArrayHelper) => (
      <>
        <div className={`${styles.headerRow} ${styles.row}`}>
          <div className={`required ${styles.textCol}`}>Text</div>
          <div className={styles.textCol}>Yes Message</div>
          <div className={styles.textCol}>No Message</div>
          <div className={styles.emailWhenCol}>Email When</div>
          <div className={styles.buttonsColumn} />
        </div>
        {questions.map((question, questionIndex) => (
          <div className={styles.row} key={question.id}>
            <div className={styles.textCol}>
              <InputText
                title={question.text}
                name={`sections.${sectionIndex}.questions.${questionIndex}.text`}
                maxLength={255}
              />
              <FormControlErrorMessage
                name={`sections.${sectionIndex}.questions.${questionIndex}.text`}
              />
            </div>

            <InputText
              className={styles.textCol}
              name={`sections.${sectionIndex}.questions.${questionIndex}.yesMessage`}
              maxLength={255}
            />

            <InputText
              className={styles.textCol}
              name={`sections.${sectionIndex}.questions.${questionIndex}.noMessage`}
              maxLength={255}
            />

            <NumericSelect
              className={styles.emailWhenCol}
              name={`sections.${sectionIndex}.questions.${questionIndex}.emailWhen`}
            >
              <option value="0">Never</option>
              <option value="1">Yes</option>
              <option value="2">No</option>
            </NumericSelect>

            <div className={styles.buttonsColumn}>
              <Button
                variant="info"
                size="sm"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  questionsArrayHelper.insert(
                    questionIndex + 1,
                    QuestionFactory.Create(),
                  );
                }}
              >
                <FontAwesomeIcon icon="plus" />
              </Button>
              {questions.length > 1 && (
                <Button
                  variant="danger"
                  size="sm"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    questionsArrayHelper.remove(questionIndex);
                  }}
                >
                  <FontAwesomeIcon icon="times" />
                </Button>
              )}
            </div>
          </div>
        ))}
      </>
    )}
  />
);

export default QuestionList;
